import {inject, Pipe, PipeTransform} from '@angular/core';
import * as moment from 'moment';
import {Moment} from 'moment';
import {TimezoneService} from 'src/app/services/timezone.service';

@Pipe({
  name: 'moment',
})
export class MomentPipe implements PipeTransform {
  private timezoneService = inject(TimezoneService);

  public transform(value: Date | Moment | string, format: string): string {
    if (!value) {
      return '';
    } else {
      return moment(value)
        .tz(this.timezoneService.getTimeZone())
        .format(format || 'M/D/YYYY');
    }
  }
}
